import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import { NavigationService } from 'src/app/services/navigation.service';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['header.component.scss'],
})
export class HeaderComponent implements OnInit {
	selectedTypeValue: PreorderType = PreorderType.TAKE_AWAY;
	@Input() allowedPreorderTypes: PreorderType[];
	@Input() set selectedType(value: PreorderType) {
		if (value) {
			this.selectedTypeValue = value;
			this.cdr.detectChanges();
		}
	}
	@Input() customer: Customer;

	@Output() selectType = new EventEmitter<PreorderType>();
	@Output() back = new EventEmitter<void>();
	@Output() searchValue = new EventEmitter<string>();
	preorderTypes = [PreorderType.TAKE_AWAY, PreorderType.DELIVERY];
	public isOpen = false;
	searchControl = new FormControl('');

	constructor(
		private popover: PopoverController,
		public translate: TranslateService,
		private navService: NavigationService,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.searchControl.valueChanges.subscribe(v => {
			console.log(v);
			this.searchValue.emit(v);
		});
	}
	goBack() {
		this.back.emit();
	}

	login() {
		this.navService.signIn();
	}

	onSelectType(type: PreorderType) {
		this.selectType.emit(type);
	}
}
